module.exports = __webpack_public_path__ + "img/excel-icon.fa7afa50.svg";